import { render, staticRenderFns } from "./HmnEducationalMajor.vue?vue&type=template&id=376a323e&scoped=true"
import script from "./HmnEducationalMajor.vue?vue&type=script&lang=js"
export * from "./HmnEducationalMajor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376a323e",
  null
  
)

export default component.exports